import { styled } from '@mui/material/styles';

export interface LogoProps {
  /**
   * Size of the logo
   * - 'small': 24px (suitable for compact UI elements)
   * - 'medium': 32px (suitable for navbars)
   * - 'large': 48px (suitable for auth pages, headers)
   */
  size?: 'small' | 'medium' | 'large';
  /**
   * Additional CSS class name for custom styling
   */
  className?: string;
}

const sizeMap = {
  small: 24,
  medium: 32,
  large: 48,
} as const;

const StyledImg = styled('img')<{ logoSize: number }>(({ logoSize }) => ({
  width: logoSize,
  height: logoSize,
  transition: 'transform 0.3s ease',
}));

/**
 * Logo component displaying the Lord of Venues favicon
 * Supports different sizes and includes hover animation
 */
export function Logo({ size = 'medium', className }: LogoProps) {
  const logoSize = sizeMap[size];

  return (
    <StyledImg src="/favicon.svg" alt="Lord of Venues" logoSize={logoSize} className={className} />
  );
}
